export default __webpack_public_path__ + "static/media/logo.a1381a28.png";